module.exports = __webpack_public_path__ + "static/media/ExtremeWireless-WiNG-Logo_RGB.59b51a54.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ExtremeWireless-WiNG-Logo_RGB.png
// module id = 33
// module chunks = 0